import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { FlexModule } from "@vp/shared/directives/flex";
import { LegalNoticeComponent } from "./legal-notice.component";

@NgModule({
  imports: [
    CommonModule,
    FlexModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatIconModule,
    ReactiveFormsModule
  ],
  declarations: [LegalNoticeComponent],
  exports: [LegalNoticeComponent]
})
export class LegalNoticeModule {}
